import { createContext, useState } from "react";

export const CollectionFormContext = createContext();

export const CollectionFormContextProvider = ({ children }) => {
    const dates = {
        from: null,
        to: null,
    }

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [date, setDate] = useState(dates);

    const contextValue = {
        selectedProducts,
        setSelectedProducts,
        date,
        setDate,
    };

    return (
        <CollectionFormContext.Provider value={ contextValue }>
            { children }
        </CollectionFormContext.Provider>
    );
}
